module.exports = __webpack_public_path__ + "media/images/svgs/loader-b1ea7821459b5df965cfcc71b67e112b.svg";